(function(){
var I18N={
  de:{search:'Produkt suchen, z.B. DELTA Pro, RIVER 2...',reset:'Zurücksetzen',all:'Alle',found:function(n){return n+' Produkt'+(n!==1?'e':'')+' gefunden'},empty:'Keine Produkte gefunden.',view:'Anzeigen',pdf:'PDF-Download',conformity:'Technische Dokumente',manuals:'Handbücher',lang:'de_DE',confDesc:'EU-Konformitätserklärung',
    cats:{'Tragbare Powerstationen':'Tragbare Powerstationen','Heimbatterie':'Heimbatterie','Balkonkraftwerke':'Balkonkraftwerke','Solarpanele':'Solarpanele','Intelligente Geräte':'Intelligente Geräte','Power Kits':'Power Kits','Zubehör':'Zubehör','App':'App'}},
  fr:{search:'Rechercher un produit, ex. DELTA Pro, RIVER 2...',reset:'Réinitialiser',all:'Tous',found:function(n){return n+' produit'+(n!==1?'s':'')+' trouvé'+(n!==1?'s':'')},empty:'Aucun produit trouvé.',view:'Afficher',pdf:'Télécharger PDF',conformity:'Documents techniques',manuals:'Manuels',lang:'fr_FR',confDesc:'Déclaration UE de conformité',
    cats:{'Tragbare Powerstationen':'Stations portables','Heimbatterie':'Batterie maison','Balkonkraftwerke':'Centrales balcon','Solarpanele':'Panneaux solaires','Intelligente Geräte':'Appareils intelligents','Power Kits':'Power Kits','Zubehör':'Accessoires','App':'App'}},
  it:{search:'Cerca prodotto, es. DELTA Pro, RIVER 2...',reset:'Reimposta',all:'Tutti',found:function(n){return n+' prodott'+(n!==1?'i':'o')+' trovato'},empty:'Nessun prodotto trovato.',view:'Visualizza',pdf:'Scarica PDF',conformity:'Documenti tecnici',manuals:'Manuali',lang:'it_IT',confDesc:'Dichiarazione UE di conformità',
    cats:{'Tragbare Powerstationen':'Stazioni portatili','Heimbatterie':'Batteria domestica','Balkonkraftwerke':'Centrali da balcone','Solarpanele':'Pannelli solari','Intelligente Geräte':'Dispositivi intelligenti','Power Kits':'Power Kits','Zubehör':'Accessori','App':'App'}},
  en:{search:'Search product, e.g. DELTA Pro, RIVER 2...',reset:'Reset',all:'All',found:function(n){return n+' product'+(n!==1?'s':'')+' found'},empty:'No products found.',view:'View',pdf:'PDF Download',conformity:'Technical Documents',manuals:'Manuals',lang:'en_US',confDesc:'EU Declaration of Conformity',
    cats:{'Tragbare Powerstationen':'Portable Power Stations','Heimbatterie':'Home Battery','Balkonkraftwerke':'Balcony Power Plants','Solarpanele':'Solar Panels','Intelligente Geräte':'Smart Devices','Power Kits':'Power Kits','Zubehör':'Accessories','App':'App'}}
};

var PRODUCTS=[
  {cat:'Tragbare Powerstationen',name:'DELTA Pro 3',slug:'delta-pro-3'},
  {cat:'Tragbare Powerstationen',name:'DELTA Pro Ultra',slug:'delta-pro-ultra'},
  {cat:'Tragbare Powerstationen',name:'DELTA Pro',slug:'delta-pro'},
  {cat:'Tragbare Powerstationen',name:'DELTA 3 Ultra Plus',slug:'delta-3-ultra-plus'},
  {cat:'Tragbare Powerstationen',name:'DELTA 3 Max Plus',slug:'delta-3-max-plus'},
  {cat:'Tragbare Powerstationen',name:'DELTA 3 Plus',slug:'delta-3-plus'},
  {cat:'Tragbare Powerstationen',name:'DELTA 2 Max',slug:'delta-2-max'},
  {cat:'Tragbare Powerstationen',name:'DELTA 2',slug:'delta-2'},
  {cat:'Tragbare Powerstationen',name:'DELTA Max',slug:'delta-max'},
  {cat:'Tragbare Powerstationen',name:'DELTA Mini',slug:'delta-mini'},
  {cat:'Tragbare Powerstationen',name:'RIVER 3 Plus',slug:'river-3-plus'},
  {cat:'Tragbare Powerstationen',name:'RIVER 3',slug:'river-3'},
  {cat:'Tragbare Powerstationen',name:'RIVER 2 Pro',slug:'river-2-pro'},
  {cat:'Tragbare Powerstationen',name:'RIVER 2 Max',slug:'river-2-max'},
  {cat:'Tragbare Powerstationen',name:'RIVER 2',slug:'river-2'},
  {cat:'Tragbare Powerstationen',name:'RIVER Pro',slug:'river-pro'},
  {cat:'Tragbare Powerstationen',name:'RIVER Max',slug:'river-max'},
  {cat:'Tragbare Powerstationen',name:'RIVER Mini',slug:'river-mini'},
  {cat:'Heimbatterie',name:'PowerOcean Plus',slug:'powerocean-plus'},
  {cat:'Heimbatterie',name:'PowerOcean',slug:'powerocean'},
  {cat:'Heimbatterie',name:'Power Hub 3000',slug:'power-hub-3000'},
  {cat:'Heimbatterie',name:'Power Hub 2000',slug:'power-hub-2000'},
  {cat:'Balkonkraftwerke',name:'STREAM',slug:'stream'},
  {cat:'Balkonkraftwerke',name:'PowerStream 800W',slug:'powerstream'},
  {cat:'Balkonkraftwerke',name:'PowerStream 600W',slug:'powerstream-600'},
  {cat:'Solarpanele',name:'400W Starres Panel',slug:'400w-rigid-solar-panel'},
  {cat:'Solarpanele',name:'220W Bifacial Panel',slug:'220w-bifacial-portable-solar-panel'},
  {cat:'Solarpanele',name:'160W Faltbares Panel',slug:'160w-portable-solar-panel'},
  {cat:'Solarpanele',name:'100W Faltbares Panel',slug:'100w-portable-solar-panel'},
  {cat:'Intelligente Geräte',name:'Smart Home Panel 2',slug:'smart-home-panel-2'},
  {cat:'Intelligente Geräte',name:'Smart Generator',slug:'smart-generator'},
  {cat:'Intelligente Geräte',name:'WAVE 3',slug:'wave-3'},
  {cat:'Intelligente Geräte',name:'WAVE 2',slug:'wave-2'},
  {cat:'Intelligente Geräte',name:'GLACIER Classic 35L',slug:'glacier-classic-35l'},
  {cat:'Intelligente Geräte',name:'GLACIER',slug:'glacier'},
  {cat:'Power Kits',name:'Power Kit - Hub 3000',slug:'power-kit-power-hub-3000'},
  {cat:'Power Kits',name:'Power Kit - Hub 2000',slug:'power-kit-power-hub-2000'},
  {cat:'Zubehör',name:'DELTA 2 Max Zusatzakku',slug:'delta-2-max-extra-battery'},
  {cat:'Zubehör',name:'DELTA Pro Zusatzakku',slug:'delta-pro-extra-battery'},
  {cat:'Zubehör',name:'RIVER 2 Max Zusatzakku',slug:'river-2-max-extra-battery'},
  {cat:'App',name:'Power Manager',slug:'power-manager'}
];

var CONFORMITY=[
  {cat:'Tragbare Powerstationen',name:'DELTA Pro 3',slug:'delta-pro-3'},
  {cat:'Tragbare Powerstationen',name:'DELTA Pro Ultra',slug:'delta-pro-ultra'},
  {cat:'Tragbare Powerstationen',name:'DELTA Pro',slug:'delta-pro'},
  {cat:'Tragbare Powerstationen',name:'DELTA 3 Ultra Plus',slug:'delta-3-ultra-plus'},
  {cat:'Tragbare Powerstationen',name:'DELTA 3 Max Plus',slug:'delta-3-max-plus'},
  {cat:'Tragbare Powerstationen',name:'DELTA 3 Plus',slug:'delta-3-plus'},
  {cat:'Tragbare Powerstationen',name:'DELTA 2 Max',slug:'delta-2-max'},
  {cat:'Tragbare Powerstationen',name:'DELTA 2',slug:'delta-2'},
  {cat:'Tragbare Powerstationen',name:'DELTA Max',slug:'delta-max'},
  {cat:'Tragbare Powerstationen',name:'DELTA Mini',slug:'delta-mini'},
  {cat:'Tragbare Powerstationen',name:'RIVER 3 Plus',slug:'river-3-plus'},
  {cat:'Tragbare Powerstationen',name:'RIVER 3',slug:'river-3'},
  {cat:'Tragbare Powerstationen',name:'RIVER 2 Pro',slug:'river-2-pro'},
  {cat:'Tragbare Powerstationen',name:'RIVER 2 Max',slug:'river-2-max'},
  {cat:'Tragbare Powerstationen',name:'RIVER 2',slug:'river-2'},
  {cat:'Tragbare Powerstationen',name:'RIVER Pro',slug:'river-pro'},
  {cat:'Heimbatterie',name:'PowerOcean Plus',slug:'powerocean-plus'},
  {cat:'Heimbatterie',name:'PowerOcean',slug:'powerocean'},
  {cat:'Heimbatterie',name:'Power Hub 3000',slug:'power-hub-3000'},
  {cat:'Heimbatterie',name:'Power Hub 2000',slug:'power-hub-2000'},
  {cat:'Balkonkraftwerke',name:'STREAM',slug:'stream'},
  {cat:'Balkonkraftwerke',name:'PowerStream 800W',slug:'powerstream'},
  {cat:'Balkonkraftwerke',name:'PowerStream 600W',slug:'powerstream-600'},
  {cat:'Solarpanele',name:'400W Starres Panel',slug:'400w-rigid-solar-panel'},
  {cat:'Intelligente Geräte',name:'Smart Home Panel 2',slug:'smart-home-panel-2'},
  {cat:'Intelligente Geräte',name:'Smart Generator',slug:'smart-generator'},
  {cat:'Intelligente Geräte',name:'WAVE 3',slug:'wave-3'},
  {cat:'Intelligente Geräte',name:'WAVE 2',slug:'wave-2'},
  {cat:'Intelligente Geräte',name:'GLACIER Classic 35L',slug:'glacier-classic-35l'},
  {cat:'Intelligente Geräte',name:'GLACIER',slug:'glacier'},
  {cat:'Power Kits',name:'Power Kit - Hub 3000',slug:'power-kit-power-hub-3000'},
  {cat:'Power Kits',name:'Power Kit - Hub 2000',slug:'power-kit-power-hub-2000'}
];

var DL={de:'https://www.ecoflow.com/de/support/download/index',fr:'https://www.ecoflow.com/fr/support/download/index',it:'https://www.ecoflow.com/it/support/download/index',en:'https://www.ecoflow.com/en/support/download/index'};
var MB='https://manuals.ecoflow.com/eu/product/';
var ICON_EYE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;flex-shrink:0"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>';
var ICON_DL='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;flex-shrink:0"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
var ICON_SH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;flex-shrink:0"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>';

var LANG='de',CAT='all',TAB='manuals';

window.efSetLang=function(lang){
  LANG=lang;CAT='all';
  ['de','fr','it','en'].forEach(function(l){document.getElementById('ef-btn-'+l).classList.toggle('ef-active',l===lang);});
  var t=I18N[lang];
  document.getElementById('ef-search').placeholder=t.search;
  document.getElementById('ef-reset-label').textContent=t.reset;
  document.getElementById('ef-tab-manuals-label').textContent=t.manuals;
  document.getElementById('ef-tab-conformity-label').textContent=t.conformity;
  document.getElementById('ef-search').value='';
  efBuildCats();efRender();
};

window.efSetTab=function(tab){
  TAB=tab;CAT='all';
  document.getElementById('ef-tab-manuals').classList.toggle('ef-active',tab==='manuals');
  document.getElementById('ef-tab-conformity').classList.toggle('ef-active',tab==='conformity');
  document.getElementById('ef-search').value='';
  efBuildCats();efRender();
};

window.efReset=function(){
  document.getElementById('ef-search').value='';
  CAT='all';efBuildCats();efRender();
};

function efBuildCats(){
  var t=I18N[LANG],data=TAB==='manuals'?PRODUCTS:CONFORMITY,seen={},cats=['all'];
  data.forEach(function(p){if(!seen[p.cat]){seen[p.cat]=true;cats.push(p.cat);}});
  document.getElementById('ef-cat-bar').innerHTML=cats.map(function(c){
    var label=c==='all'?t.all:(t.cats[c]||c);
    return '<button class="ef-cat-btn'+(c===CAT?' ef-active':'')+'" onclick="efSetCat(\''+c+'\')">'+label+'</button>';
  }).join('');
}
window.efSetCat=function(cat){CAT=cat;efBuildCats();efRender();};

function efRender(){
  var t=I18N[LANG],q=document.getElementById('ef-search').value.toLowerCase().trim();
  var data=TAB==='manuals'?PRODUCTS:CONFORMITY;
  var filtered=data.filter(function(p){
    var cl=t.cats[p.cat]||p.cat;
    return (CAT==='all'||p.cat===CAT)&&(!q||p.name.toLowerCase().indexOf(q)!==-1||cl.toLowerCase().indexOf(q)!==-1);
  });
  document.getElementById('ef-count').textContent=t.found(filtered.length);
  var grid=document.getElementById('ef-grid');
  if(!filtered.length){grid.innerHTML='<div class="ef-empty">'+t.empty+'</div>';return;}
  if(TAB==='manuals'){
    grid.innerHTML=filtered.map(function(p){
      var mu=MB+p.slug+'?lang='+t.lang+'&source=desktop';
      var cl=t.cats[p.cat]||p.cat;
      return '<div class="ef-card"><div class="ef-card-cat">'+cl+'</div><div class="ef-card-name">'+p.name+'</div><div class="ef-card-actions">'+
        '<a class="ef-pill" href="'+mu+'" target="_blank" rel="noopener noreferrer">'+ICON_EYE+' '+t.view+'</a>'+
        '<a class="ef-pill" href="'+DL[LANG]+'" target="_blank" rel="noopener noreferrer">'+ICON_DL+' '+t.pdf+'</a>'+
        '</div></div>';
    }).join('');
  } else {
    grid.innerHTML=filtered.map(function(p){
      var mu=MB+p.slug+'?lang='+t.lang+'&source=desktop';
      var cl=t.cats[p.cat]||p.cat;
      return '<div class="ef-card"><div class="ef-card-cat">'+cl+'</div><div class="ef-card-name">'+p.name+'</div>'+
        '<div class="ef-card-desc">'+t.confDesc+'</div>'+
        '<div class="ef-card-actions"><a class="ef-pill" href="'+mu+'" target="_blank" rel="noopener noreferrer">'+ICON_SH+' '+t.view+'</a></div></div>';
    }).join('');
  }
}

efBuildCats();efRender();
})();